import type { components } from "./generated/schema";

export type ApiErrorShape = components["schemas"]["ErrorEnvelope"];

export class ApiError extends Error {
  readonly code: string;
  readonly fieldErrors: ApiErrorShape["error"]["field_errors"];
  readonly details: ApiErrorShape["error"]["details"];

  constructor(shape: ApiErrorShape) {
    super(shape.error.message);
    this.name = "ApiError";
    this.code = shape.error.code;
    this.fieldErrors = shape.error.field_errors;
    this.details = shape.error.details;
  }
}

export async function apiErrorFromResponse(response: Response): Promise<ApiError> {
  return new ApiError((await response.json()) as ApiErrorShape);
}
